export const getPayeeProductLink = (payeeProductHandleId, payeeHandleId = "") => {
    return `${window.location.origin}/${payeeHandleId}/p/${payeeProductHandleId}`
}